export const ActionTypes = {
  CREATE_CITATION_SOURCE_TYPE_SELECTED: 'CREATE_CITATION/SOURCE_TYPE_SELECTED',
  CREATE_CITATION_QUERY_ENTERED: 'CREATE_CITATION/QUERY_ENTERED',
  SOURCE_SELECTION_COMPLETED: 'CREATE_CITATION/SOURCE_SELECTION_COMPLETED',
  SOURCE_SELECTION_AUTOCITE_REQUEST_FAILED:
    'CREATE_CITATION/SOURCE_SELECTION_AUTOCITE_REQUEST_FAILED',
  CREATE_CITATION_SOURCE_SELECTED: 'CREATE_CITATION/SOURCE_SELECTED',
  CREATE_CITATION_JOURNAL_TAB_SELECTED: 'CREATE_CITATION/JOURNAL_TAB_SELECTED',
  CREATE_CITATION_SEARCH_RESULTS_PAGE_LOADED:
    'CREATE_CITATION/SEARCH_RESULTS_PAGE_LOADED',
  CREATE_CITATION_SEARCH_SUCCEEDED: 'CREATE_CITATION/SEARCH_SUCCEEDED',
  CREATE_CITATION_SEARCH_FAILED: 'CREATE_CITATION/SEARCH_FAILED',
  ON_NEW_CITATION: 'CREATE_CITATION/ON_NEW_CITATION',
  SET_AUTOCITE_V0_RIO_OPT_FLAG: 'CREATE_CITATION/SET_AUTOCITE_V0_RIO_OPT_FLAG',
  SET_AUTOCITE_API_VERSION: 'CREATE_CITATION/SET_AUTOCITE_API_VERSION',
  SET_AUTH_MODAL_EXP_FLAG: 'CREATE_CITATION/SET_AUTH_MODAL_EXP_FLAG',
  SET_ONE_CLICK_FLAG: 'CREATE_CITATION/SET_ONE_CLICK_FLAG',
  ONE_CLICK_CITATION: 'CREATE_CITATION/ONE_CLICK_CITATION',
  SET_AD_UNLOCK_VARIANT: 'CREATE_CITATION/SET_AD_UNLOCK_VARIANT',
} as const
